// const siteReport = () =>
//   import("@/views/operation-analysis/site-report/site-report.vue");
// const pileReport = () =>
//   import("@/views/operation-analysis/pile-report/pile-report.vue");
const channelReport = () => import("@/views/operation-analysis/channel-report/channel-report.vue");
// const kaReport = () =>
//   import("@/views/operation-analysis/ka-report/ka-report.vue");
// const cardDataReport = () =>
//   import("@/views/operation-analysis/card-data-report/card-data-report.vue");
const overview = () => import("@/views/operation-analysis/overview/overview.vue");
// const siteDiagnosis = () =>
//   import("@/views/operation-analysis/site-diagnosis/site-diagnosis.vue");
const routerList = [
    // {
    //   path: "/operation-analysis/site-report",
    //   name: "站点报表",
    //   component: siteReport,
    // },
    // {
    //   path: "/operation-analysis/pile-report",
    //   name: "电桩报表",
    //   component: pileReport,
    // },
    {
        path: "/operation-analysis/channel-report",
        name: "渠道报表",
        component: channelReport,
    },
    // {
    //   path: "/operation-analysis/ka-report",
    //   name: "企业报表",
    //   component: kaReport,
    // },
    // {
    //   path: "/operation-analysis/card-data-report",
    //   name: "刷卡数据报表",
    //   component: cardDataReport,
    // },
    {
        path: "/operation-analysis/overview",
        name: "全局纵览",
        component: overview,
    },
    // {
    //   path: "/operation-analysis/site-diagnosis",
    //   name: "站点诊断",
    //   component: siteDiagnosis,
    // },
    {
        path: "/operation-analysis/income-analysis",
        name: "运营分析",
        component: () => import("@/views/operation-analysis/analysis-operate/analysis-income/analysis-income.vue"),
    },
    {
        path: "/operation-analysis/use-analysis",
        name: "使用分析",
        component: () => import("@/views/operation-analysis/analysis-operate/analysis-use/analysis-use.vue"),
    },
    {
        path: "/operation-analysis/site-ranking",
        name: "站点排名",
        component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/site-ranking.vue"),
        children: [
            {
                path: "/operation-analysis/site-ranking/table-order",
                name: "充电订单量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/table-order/table-order.vue"),
                meta: {
                    nameKey: "siteRankingChargeOrder",
                },
            },
            {
                path: "/operation-analysis/site-ranking/table-charging-duration",
                name: "充电订单量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/table-charging-duration/table-charging-duration.vue"),
                meta: {
                    nameKey: "siteRankingChargeTime",
                },
            },
            {
                path: "/operation-analysis/site-ranking/table-utilization-rate",
                name: "充电订单量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/table-utilization-rate/table-utilization-rate.vue"),
                meta: {
                    nameKey: "siteRankingChargeUtilizationRate",
                },
            },
            {
                path: "/operation-analysis/site-ranking/table-utilization",
                name: "充电订单量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/table-utilization/table-utilization.vue"),
                meta: {
                    nameKey: "siteRankingChargeUtilization",
                },
            },
            {
                path: "/operation-analysis/site-ranking/revenue",
                name: "营收排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/revenue/revenue.vue"),
                meta: {
                    nameKey: "siteRankingRevenue",
                },
            },
            {
                path: "/operation-analysis/site-ranking/revenue/revenue-table",
                name: "营收排名列表",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/revenue-table/revenue-table.vue"),
                meta: {
                    nameKey: "siteRankingTotalRevenue",
                },
            },
            {
                path: "/operation-analysis/site-ranking/revenue/revenue-table-service",
                name: "服务费营收排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/revenue-table-service/revenue-table-service.vue"),
                meta: {
                    nameKey: "siteRankingServerRevenue",
                },
            },
            {
                path: "/operation-analysis/site-ranking/revenue/revenue-table-electricity",
                name: "电费营收排名及占比",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/revenue-table-electricity/revenue-table-electricity.vue"),
                meta: {
                    nameKey: "siteRankingDfRevenue",
                },
            },
            {
                path: "/operation-analysis/site-ranking/revenue/revenue-table-delay",
                name: "电费营收排名及占比",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/revenue-table-delay/revenue-table-delay.vue"),
                meta: {
                    nameKey: "siteRankingDelayRevenue",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl",
                name: "充电量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl/dl.vue"),
                meta: {
                    nameKey: "siteRankingCharging",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl/dl-table",
                name: "充电订单量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl-table/dl-table.vue"),
                meta: {
                    nameKey: "siteRankingChargeDlTable",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl/dl-table-sharp",
                name: "尖时段充电量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl-table-sharp/dl-table-sharp.vue"),
                meta: {
                    nameKey: "siteRankingChargeDlTableSharp",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl/dl-table-peak",
                name: "锋时段充电量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl-table-peak/dl-table-peak.vue"),
                meta: {
                    nameKey: "siteRankingChargeDlTablePeak",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl/dl-table-flat",
                name: "平时段充电量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl-table-flat/dl-table-flat.vue"),
                meta: {
                    nameKey: "siteRankingChargeDlTableFlat",
                },
            },
            {
                path: "/operation-analysis/site-ranking/dl/dl-table-valley",
                name: "谷时段充电量排名",
                component: () => import("@/views/operation-analysis/analysis-operate/site-ranking/children/dl-table-valley/dl-table-valley.vue"),
                meta: {
                    nameKey: "siteRankingChargeDlTableValley",
                },
            },
        ],
    },
    {
        path: "/operation-analysis/site-analysis",
        name: "单站点分析",
        component: () => import("@/views/operation-analysis/analysis-operate/analysis-site/analysis-site.vue"),
        children: [
            {
                path: "/operation-analysis/site-analysis/details",
                name: "单站点分析详情",
                component: () => import("@/views/operation-analysis/analysis-operate/analysis-site/children/details/details.vue"),
                meta: {
                    nameKey: "siteAnalysisDetails",
                },
            },
        ],
    },
    {
        path: "/operation-analysis/user-analysis/revenue-overview",
        name: "用户营收概览",
        component: () => import("@/views/operation-analysis/analysls-user/revenue-overview/revenue-overview.vue"),
    },
    {
        path: "/operation-analysis/user-analysis/revenue-analysis",
        name: "用户营收分析",
        component: () => import("@/views/operation-analysis/analysls-user/revenue-analysis/revenue-analysis.vue"),
    },
    {
        path: "/operation-analysis/user-analysis/use-overview",
        name: "用户营收分析",
        component: () => import("@/views/operation-analysis/analysls-user/use-overview/use-overview.vue"),
    },
    {
        path: "/operation-analysis/user-analysis/use-analysis",
        name: "用户使用分析",
        component: () => import("@/views/operation-analysis/analysls-user/use-analysis/use-analysis.vue"),
    },
    {
        path: "/operation-analysis/user-analysis/user-ranking",
        name: "用户使用分析",
        component: () => import("@/views/operation-analysis/analysls-user/user-ranking/user-ranking.vue"),
        children: [
            {
                path: "/operation-analysis/user-analysis/user-ranking/more",
                name: "个人用户总营收排名",
                component: () => import("@/views/operation-analysis/analysls-user/user-ranking/children/user-ranking-more/user-ranking-more.vue"),
                meta: {
                    nameKey: "userRankingMore",
                },
            },
        ],
    },
    {
        path: "/operation-analysis/user-analysis/single-user",
        name: "单用户分析",
        component: () => import("@/views/operation-analysis/analysls-user/user-single/user-single.vue"),
        children: [
            {
                path: "/operation-analysis/user-analysis/single-user/user-details",
                name: "单用户分析详情",
                component: () => import("@/views/operation-analysis/analysls-user/user-single/children/user-details/user-details.vue"),
                meta: {
                    nameKey: "singleUserDetails",
                },
            },
            {
                path: "/operation-analysis/user-analysis/single-user/ent-details",
                name: "企业用户分析详情",
                component: () => import("@/views/operation-analysis/analysls-user/user-single/children/user-details/user-details.vue"),
                meta: {
                    nameKey: "singleUserDetails",
                },
            },
            {
                path: "/operation-analysis/user-analysis/single-user/card-details",
                name: "非实名卡用户分析详情",
                component: () => import("@/views/operation-analysis/analysls-user/user-single/children/user-details/user-details.vue"),
                meta: {
                    nameKey: "singleUserDetails",
                },
            },
        ],
    },
    {
        path: "/operation-analysis/construction-analysis/site-analysis",
        name: "站点建设分析",
        component: () => import("@/views/operation-analysis/analysis-construction/site-analysis/site-analysis.vue"),
    },
    {
        path: "/operation-analysis/construction-analysis/site-ranking",
        name: "站点建设排名",
        component: () => import("@/views/operation-analysis/analysis-construction/site-ranking/site-ranking.vue"),
        children: [
            {
                path: "/operation-analysis/construction-analysis/site-ranking/pile",
                name: "充电桩建设排名",
                component: () => import("@/views/operation-analysis/analysis-construction/site-ranking/children/pile/pile.vue"),
                meta: {
                    nameKey: "siteRankingPile",
                },
            },
            {
                path: "/operation-analysis/construction-analysis/site-ranking/gun",
                name: "充电枪建设排名",
                component: () => import("@/views/operation-analysis/analysis-construction/site-ranking/children/gun/gun.vue"),
                meta: {
                    nameKey: "siteRankingGun",
                },
            },
            {
                path: "/operation-analysis/construction-analysis/site-ranking/power",
                name: "额定功率建设排名",
                component: () => import("@/views/operation-analysis/analysis-construction/site-ranking/children/power/power.vue"),
                meta: {
                    nameKey: "siteRankingPower",
                },
            },
        ],
    },
    // {
    //   path: "/operation-analysis/offcard-analysis/revenue-overview",
    //   name: "离线卡营收概览",
    //   component: () =>
    //     import(
    //       "@/views/operation-analysis/analysis-offcard/revenue-overview/revenue-overview.vue"
    //     ),
    // },
    {
        path: "/operation-analysis/offcard-analysis/revenue-analysis",
        name: "离线卡营收分析",
        component: () => import("@/views/operation-analysis/analysis-offcard/revenue-analysis/revenue-analysis.vue"),
    },
    // {
    //   path: "/operation-analysis/offcard-analysis/use-overview",
    //   name: "离线卡使用总览",
    //   component: () =>
    //     import(
    //       "@/views/operation-analysis/analysis-offcard/use-overview/use-overview.vue"
    //     ),
    // },
    {
        path: "/operation-analysis/offcard-analysis/use-analysis",
        name: "离线卡使用分析",
        component: () => import("@/views/operation-analysis/analysis-offcard/use-analysis/use-analysis.vue"),
    },
];
export default routerList;
